import { render } from "./Widget13.vue?vue&type=template&id=35b33a22&ts=true"
import script from "./Widget13.vue?vue&type=script&lang=ts"
export * from "./Widget13.vue?vue&type=script&lang=ts"

import exportComponent from "D:\\CTL-Project\\Mbf5_ZMP_CongAn\\CAXaAnQuang\\web-ui\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__